jQuery(function($) {
  // mobile (primary) nav functions
  $('#toggle').click(function() {
    var slider_width = $('#mobile-nav').width();
    // if the mobile nav is hidden...
    if($('#mobile-nav').css('left') == -slider_width+'px' && !$(this).is(':animated'))
    {
      // show the mobile nav
      $('#mobile-nav').animate({'left': '+='+slider_width});
      // update the toggle icon
      $('#mobile-nav-toggle').removeClass('fas fa-align-left');
      $('#mobile-nav-toggle').addClass('fas fa-times');
    }
    // if the mobile nav is on-screen...
    else
    {
      if(!$(this).is(':animated'))
      {
        // hide the mobile nav
        $('#mobile-nav').animate({'left': '-='+slider_width});
        // update the toggle icon
        $('#mobile-nav-toggle').removeClass('fas fa-times');
        $('#mobile-nav-toggle').addClass('fas fa-align-left');
      }
    }
  });
  // handle viewport re-sizing
  $( window ).resize(function() {
    // set mobile nav width equal to viewport width
    $('#mobile-nav').width($(window).width());
    // if the mobile nav is hidden...
    if($('#mobile-nav').css('left') != 0+'px') {
      // update the horizontal position of the mobile nav to be at the off-screen left-edge
      $('#mobile-nav').css('left', -$(window).width());
    }
  });
  // mobile (section) nav functions
  var section_nav_icon = $('#mobile-section-nav-icon');
  var section_nav_hidden_menu_items = $('#mobile-section-nav .menu-item:not(.current-menu-item)');
  section_nav_icon.click(function() {
    // when clicked, update the icon and toggle visibility of the non-current section nav menu items
    section_nav_icon.toggleClass('fa-angle-down');
    section_nav_icon.toggleClass('fa-angle-up');
    section_nav_hidden_menu_items.toggle();
  });
});



// WEBPACK FOOTER //
// ./scripts/navFunctions.js